@for (field of field.fieldGroup; track field) {
  <formly-field [field]="field"></formly-field>
}

@if (props.addClicked) {
  <div class="row mb-2">
    <div class="col">
      @if (!props.customAddTemplate) {
        <button type="button" class="btn btn-primary btn-sm" (click)="props.addClicked(model, field)">
          <i class="icon-add"></i>
          Add
        </button>
      }
      @if (props.customAddTemplate) {
        <ng-container *ngTemplateOutlet="customAddTemplate"></ng-container>
      }
    </div>
  </div>
}

<ng-template #customAddTemplate>
  <div class="row my-3">
    <div class="col-md-9 offset-md-1 d-flex justify-content-between align-items-center">
      <button
        type="button"
        class="btn-add d-flex justify-content-center align-items-center btn btn-block p-3 btn-link text-dark-green"
        (click)="props.addClicked(model, field)"
        >
        <span class="add-wrapper d-flex align-items-center justify-content-center w-100">
          <span>
            <span class="fa-stack mb-2">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="icon-add fa-stack-1x fa-inverse"></i>
            </span>
            <h3 class="text-dark-green text-wrap mb-0">
              {{ props.addText }}
            </h3>
          </span>
        </span>
      </button>

      @if (props.tooltip) {
        <i class="far fa-lg fa-question-circle pointer d-md-none text-dark-blue" (click)="openTooltip()"></i>
      }
    </div>

    <div class="col-md-2 d-flex align-items-center justify-content-center">
      <div class="d-none d-md-flex justify-content-center align-items-center">
        @if (props.tooltip) {
          <i class="far fa-lg fa-question-circle pointer text-dark-blue" (click)="openTooltip()"></i>
        }
      </div>
    </div>
  </div>
</ng-template>
